module.exports = __webpack_public_path__ + "19316a06d25e6861e5c252a1776fbf37.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ic-buy-x-get-y.png
// module id = 3152
// module chunks = 0